import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { registerUser } from "./context/AuthContext";
import { useTheme } from "./context/ThemeContext";

export default function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false); // novo estado loading
  const { isDarkMode, toggleTheme } = useTheme();
  const navigate = useNavigate(); // Correctly call the hook
  const [passwordFocus, setPasswordFocus] = useState(false);

  const passwordCriteria = {
    length: password.length >= 6,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /\d/.test(password),
    specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    noSpaces: !/\s/.test(password),
  };

  const validateEmail = (email) => {
    const salExpressRegex = /^[a-zA-Z0-9._%+-]+@salexpress\.com\.br$/;
    return salExpressRegex.test(email);
  };

  const validatePassword = (password) => {
    return Object.values(passwordCriteria).every((criterion) => criterion);
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true); // Inicia loading
    // Valida o e-mail
    if (!validateEmail(email)) {
      setError("Use um e-mail válido da Sal Express");
      setSuccessMessage("");
      setLoading(false); // Encerra loading
      return;
    }

    // Valida a senha
    if (!validatePassword(password)) {
      setError("A senha deve atender a todos os critérios listados.");
      setSuccessMessage("");
      setLoading(false);
      return;
    }

    setError("");
    try {
      const response = await registerUser(email, password);
      if (response.success) {
        setSuccessMessage("Usuário cadastrado com sucesso");
        setError("");
        setTimeout(() => {
          navigate("/");
        }, 2000);
      } else {
        setError(
          response.message && response.message.includes("auth/email-already-in-use")
            ? "Erro, email em uso"
            : response.message || "Erro ao cadastrar. Tente novamente."
        );
        setSuccessMessage("");
      }
    } catch (error) {
      setError(
        error.message && error.message.includes("auth/email-already-in-use")
          ? "Erro, email em uso"
          : "Erro no cadastro: " + error.message
      );
      setSuccessMessage("");
    }
    setLoading(false); // Encerra loading
  };

  return (
    <div
      className="h-screen w-full bg-cover bg-center bg-no-repeat flex justify-end items-center pr-40 relative"
      style={{
        backgroundImage: "url('/Login/Background.jpeg')",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-l from-salBlue to-transparent"></div>

      {/* Theme toggle button */}
      <div className="absolute top-5 left-5 z-20">
        <button
          onClick={toggleTheme}
          className="h-12 w-12 flex items-center justify-center rounded-lg cursor-pointer transition-all duration-300 bg-white/20 backdrop-blur-md hover:bg-white/30"
        >
          {isDarkMode ? (
            <svg
              className="w-8 h-8 text-yellow-400 transition-transform duration-300"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                clipRule="evenodd"
              />
            </svg>
          ) : (
            <svg
              className="w-8 h-8 text-gray-800 transition-transform duration-300"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
            </svg>
          )}
        </button>
      </div>

      <div className="absolute top-5 right-5">
        <img
          src="/Login/logo.png"
          alt="Logo SalExpress"
          className="h-12"
        />
      </div>

      <div className="h-[600px] w-[400px] border-2 border-white dark:border-dark-border rounded-xl bg-white-less/50 dark:bg-dark-surface/80 shadow-lg backdrop-blur-md flex items-center justify-center mr-20">
        <form
          className="flex flex-col items-center justify-center gap-10 w-11/12"
          onSubmit={handleRegister}
        >
          <h2 className="text-4xl font-extrabold text-center text-gray-800 dark:text-dark-text">
            Registro
          </h2>

          {/* Exibe erro ou sucesso */}
          {error && <p style={{ color: "red" }}>{error}</p>}
          {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}

          <div className="flex flex-col gap-4 w-[80%]">
            <div className="flex flex-col">
              <label htmlFor="email" className="font-bold text-gray-800 dark:text-dark-text text-lg">
                E-mail:
              </label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Digite seu e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full border-2 rounded-lg border-white dark:border-dark-border bg-gray-200/30 dark:bg-dark-card/50 shadow-md p-2 placeholder-gray-700 dark:placeholder-dark-textSecondary text-text dark:text-dark-text focus:outline-none focus:border-salBlue focus:bg-white dark:focus:bg-dark-surface focus:backdrop-blur"
              />
            </div>

            <div className="flex flex-col">
              <label
                htmlFor="password"
                className="font-bold text-gray-800 dark:text-dark-text text-lg"
              >
                Senha:
              </label>
              <input
                type="password"
                id="password"
                name="password"
                placeholder="Digite sua senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onFocus={() => setPasswordFocus(true)}
                onBlur={() => setPasswordFocus(false)}
                required
                className="w-full border-2 rounded-lg border-white dark:border-dark-border bg-gray-200/30 dark:bg-dark-card/50 shadow-md p-2 placeholder-gray-700 dark:placeholder-dark-textSecondary text-text dark:text-dark-text focus:outline-none focus:border-salBlue focus:bg-white dark:focus:bg-dark-surface focus:backdrop-blur"
              />
              {passwordFocus && (
                <ul className="text-sm mt-2">
                  <li
                    className={`${
                      passwordCriteria.length ? "text-green-600" : "text-red-600"
                    }`}
                  >
                    Pelo menos 6 caracteres
                  </li>
                  <li
                    className={`${
                      passwordCriteria.uppercase ? "text-green-600" : "text-red-600"
                    }`}
                  >
                    Pelo menos uma letra maiúscula
                  </li>
                  <li
                    className={`${
                      passwordCriteria.lowercase ? "text-green-600" : "text-red-600"
                    }`}
                  >
                    Pelo menos uma letra minúscula
                  </li>
                  <li
                    className={`${
                      passwordCriteria.number ? "text-green-600" : "text-red-600"
                    }`}
                  >
                    Pelo menos um número
                  </li>
                  <li
                    className={`${
                      passwordCriteria.specialChar ? "text-green-600" : "text-red-600"
                    }`}
                  >
                    Pelo menos um caractere especial
                  </li>
                  <li
                    className={`${
                      passwordCriteria.noSpaces ? "text-green-600" : "text-red-600"
                    }`}
                  >
                    Sem espaços
                  </li>
                </ul>
              )}
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="bg-gray-800 text-white-whiter font-bold text-xl py-2 px-8 rounded-lg shadow-lg hover:bg-salBlue transition-all hover:text-text disabled:opacity-50"
          >
            {loading ? "Carregando..." : "Registrar"}
          </button>
          <p className="text-center text-gray-800 dark:text-white-whiter mt-4">
            Já tem conta?{" "}
            <a href="/" className="text-salBlue font-bold hover:underline">
              Entre aqui!
            </a>
          </p>
        </form>
      </div>
    </div>
  );
}
